<div
  [attr.data-theme]="theme()"
  [ngClass]="theme() === 'dark' ? 'bg-neutral-800' : 'bg-white'"
  [class.overflow-auto]="overflow()"
  class="max-h-[20rem] z-20 flex flex-col text-center rounded-lg shadow-lg min-w-max text-gray-800 text-sm px-3 py-2.5"
>
  <ng-content />
</div>
